<template>
	<nav
		class="tw-w-full tw-h-16 md:tw-flex tw-flex-row tw-items-center tw-justify-between tw-bg-primary-500 tw-px-6 tw-text-white tw-text-sm lg:tw-text-base">
		<div class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-space-x-4 tw-z-40">
			<router-link
				:to="{
					name: 'Welcome',
				}">
				<img
					:src="brand.toLowerCase() === 'dulconnex' ? '/assets/img/logo-prominent.png' : `/api/get-logo.svg?type=brand&brand=${brand}`"
					alt="logo"
					class="tw-h-8 tw-mx-4" />
			</router-link>

			<PublicMenuItem
				v-for="miscItem in menuItems.filter((m) => m.alignment == 'left')"
				:key="miscItem.path"
				:path="miscItem.path"
				:icon="miscItem.icon"
				:translationKey="t(miscItem.translationKey)" />
		</div>
		<div class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-space-x-2 tw-text-white">
			<PublicMenuItem
				v-for="miscItem in menuItems.filter((m) => m.alignment == 'right')"
				:key="miscItem.path"
				:path="miscItem.path"
				:icon="miscItem.icon"
				:translationKey="t(miscItem.translationKey)" />

			<div class="tw-text-gray-50 tw-rounded-full">
				<LanguageSelector />
			</div>
		</div>
	</nav>
</template>

<script setup lang="ts">
import LanguageSelector from "../LanguageSelector/LanguageSelector.vue";
import PublicMenuItem from "../PublicMenu/PublicMenuItem.vue";
import {PropType} from "vue";
import {PublicMenuItem as PublicMenuItemType} from "../PublicMenu/PublicMenuUtils";
import { useTranslation } from "i18next-vue";


const { t } = useTranslation();

defineProps({
	menuItems: {
		type: Array as PropType<PublicMenuItemType[]>,
		required: true,
	},
	brand: {
		type: String,
		default: "prominent",
	},
});
</script>